import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {keyframes} from "@mui/system";
import {useTheme} from "@mui/material/styles";

const iconBounce = keyframes`
    0% {
        transform: scale(1);
    }
    60% {
        transform: scale(1.15);
    }
    100% {
        transform: scale(1);
    }
`;

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(32px);
    }
    to {
        opacity: 1;
        transform: none;
    }
`;

const Unauthorized = () => {
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            minHeight="80vh"
            sx={{
                animation: `${fadeIn} 0.7s cubic-bezier(.4,0,.2,1)`,
            }}
        >
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={3}
                px={5}
                py={4}
                sx={{
                    boxShadow: isDark ? "0 4px 12px rgba(0,0,0,0.5)" : theme.shadows[8],
                    borderRadius: 4,
                    background: theme.palette.background.default,
                    border: `1px solid ${theme.palette.divider}`,
                }}
            >
                <LockOutlinedIcon
                    sx={{
                        fontSize: 88,
                        color: theme.palette.error.light,
                        mb: 1,
                        animation: `${iconBounce} 0.7s cubic-bezier(.4,0,.2,1)`,
                    }}
                />
                <Typography
                    variant="h3"
                    fontWeight={900}
                    color={theme.palette.error.light}
                    gutterBottom
                    sx={{
                        letterSpacing: 1.5,
                        fontFamily: "Montserrat, Roboto, sans-serif",
                        textShadow: isDark
                            ? "0 2px 8px rgba(0,0,0,0.8)"
                            : "0 2px 8px rgba(255,255,255,0.8)",
                    }}
                >
                    Access Denied
                </Typography>
                <Typography
                    variant="body1"
                    color={theme.palette.text.secondary}
                    align="center"
                    sx={{
                        maxWidth: 400,
                        fontSize: 18,
                        fontFamily: "Inter, Roboto, sans-serif",
                        textShadow: isDark
                            ? "0 1px 4px rgba(0,0,0,0.6)"
                            : "0 1px 4px rgba(255,255,255,0.6)",
                    }}
                >
                    You do not have permission to view this page.<br/>
                    Please contact your administrator if you believe this is a mistake.
                </Typography>
            </Box>
        </Box>
    );
};

export default Unauthorized;